import { render } from "./IconPerson.vue?vue&type=template&id=19709d0a&scoped=true"
const script = {}

import "./IconPerson.vue?vue&type=style&index=0&id=19709d0a&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19709d0a"]])

export default __exports__